import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from './layout/layout.module';
import {HttpErrorModule} from './http-error/http-error.module';
import {registerLocaleData} from '@angular/common';
import {PopupModule} from '@components/popup/popup.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FavoritesModule} from '@module/favorites/favorites.module';
import {JwtInterceptor} from '~/app/shared/helpers/jwt.interceptor';
import {ErrorInterceptor} from '~/app/shared/helpers/error.interceptor';
import {UsersModule} from '@module/users/users.module';
import {NgxEchartsModule} from 'ngx-echarts';
import 'src/app/shared/echart-theme';
import * as echarts from 'echarts';
import {RouterModule} from '@angular/router';
import {HistoricModule} from '@module/historic/historic.module';
import {AdModule} from '@components/ad/ad.module';
import {FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig} from '@abacritt/angularx-social-login';
import {environment} from '~/environments/environment';
import {SearchModule} from '@module/search/search.module';
import {PipeModule} from '~/app/shared/pipe/pipe.module';
import {JoyrideModule} from 'ngx-joyride';
import {PartnersModule} from '@module/partners/partners.module';

registerLocaleData(localeFr);

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        FavoritesModule,
        UsersModule,
        PopupModule,
        SearchModule,
        PartnersModule,
        HistoricModule,
        HttpErrorModule,
        NgxEchartsModule.forRoot({
            echarts,
        }),
        RouterModule,
        AdModule,
        PipeModule,
        JoyrideModule.forRoot(),
    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'fr-FR'},
        {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(environment.google_client_id),
                    },
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider(environment.facebook_client_id),
                    },
                ],
            } as SocialAuthServiceConfig,
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
